import { createTheme, type MantineColorsTuple } from '@mantine/core';

// FixByte-Cyberorange – konsistent mit Techniker-Portal
const cyberOrange: MantineColorsTuple = [
  '#fff4e6',
  '#ffe8cc',
  '#ffd199',
  '#ffb866',
  '#ff9f33',
  '#ff8c1a',
  '#ff6600',
  '#e65c00',
  '#cc5200',
  '#b34700',
];

export const customerPortalTheme = createTheme({
  primaryColor: 'cyberOrange',
  colors: { cyberOrange },
  fontFamily: '"Outfit", -apple-system, BlinkMacSystemFont, sans-serif',
  headings: {
    fontFamily: '"Outfit", -apple-system, BlinkMacSystemFont, sans-serif',
    fontWeight: '600',
  },
  defaultRadius: 'md',
  cursorType: 'pointer',
  components: {
    Button: {
      defaultProps: { radius: 'md' },
    },
    Card: {
      defaultProps: { radius: 'lg', withBorder: true },
      styles: {
        root: {
          backgroundColor: 'var(--mantine-color-white)',
          borderColor: 'var(--mantine-color-gray-2)',
        },
      },
    },
    Paper: {
      defaultProps: { radius: 'md' },
      styles: {
        root: {
          backgroundColor: 'var(--mantine-color-white)',
        },
      },
    },
    AppShell: {
      styles: {
        header: {
          backgroundColor: 'var(--mantine-color-white)',
          borderBottom: '1px solid var(--mantine-color-gray-2)',
        },
        navbar: {
          backgroundColor: 'var(--mantine-color-gray-0)',
          borderRight: '1px solid var(--mantine-color-gray-2)',
        },
        main: {
          backgroundColor: 'var(--mantine-color-gray-0)',
        },
      },
    },
    NavLink: {
      styles: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
          '&[data-active]': {
            backgroundColor: 'var(--mantine-color-cyberOrange-0)',
            color: 'var(--mantine-color-cyberOrange-8)',
          },
        },
      },
    },
    TextInput: { defaultProps: { radius: 'md' } },
    Select: { defaultProps: { radius: 'md' } },
    Textarea: { defaultProps: { radius: 'md' } },
    Badge: { defaultProps: { radius: 'sm' } },
    Alert: { defaultProps: { radius: 'md' } },
  },
});
